export default __webpack_public_path__ + "/dist/images/producer-thumbnail.0da42d47583ea02d0a9c35850f3137fb.png";